import { render, staticRenderFns } from "./list.vue?vue&type=template&id=cfec23f2&scoped=true"
import script from "./list.vue?vue&type=script&lang=ts"
export * from "./list.vue?vue&type=script&lang=ts"
import style0 from "./list.vue?vue&type=style&index=0&id=cfec23f2&lang=scss"
import style1 from "./list.vue?vue&type=style&index=1&id=cfec23f2&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfec23f2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sahil-meshram/Documents/Eiosys/BFP-Admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cfec23f2')) {
      api.createRecord('cfec23f2', component.options)
    } else {
      api.reload('cfec23f2', component.options)
    }
    module.hot.accept("./list.vue?vue&type=template&id=cfec23f2&scoped=true", function () {
      api.rerender('cfec23f2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/follow-ups/list.vue"
export default component.exports